import { render, staticRenderFns } from "./PaymentCheckArchive.vue?vue&type=template&id=71bd03e2&"
import script from "./PaymentCheckArchive.vue?vue&type=script&lang=js&"
export * from "./PaymentCheckArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports